import { Component, OnInit } from '@angular/core';
// import { routerTransition } from '../../router.animations';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss'],
  // animations: [routerTransition()]
})
export class ContactUsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/bs_work/toMigrate_litePortal/src/app/main/main-portal/contact-us/contact-us.component.ts